import { CSSProperties } from "@mui/material/styles";

declare module "@mui/material/styles" {
  interface TypographyVariants {
    body13: CSSProperties;
    body11: CSSProperties;
    body16: CSSProperties;
  }

  interface TypographyVariantsOptions {
    body13?: CSSProperties;
    body11?: CSSProperties;
    body16?: CSSProperties;
  }

  interface TypographyPropsVariantOverrides {
    body13: true;
    body11: true;
    body16: true;
  }
}

const commonHeadingStyles = {
  lineHeight: "120%",
};

export const typography = {
  fontFamily: `"Muli", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif`,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 700,
  fontWeightBold: 800,
  h1: {
    fontSize: "6rem",
    fontWeight: 800,
    ...commonHeadingStyles,
  },
  h2: {
    fontSize: "3.75rem",
    fontWeight: 800,
    ...commonHeadingStyles,
  },
  h3: {
    fontSize: "3rem",
    fontWeight: 700,
    ...commonHeadingStyles,
  },
  h4: {
    fontSize: "2.125rem",
    fontWeight: 800,
    ...commonHeadingStyles,
  },
  h5: {
    fontSize: "1.5rem",
    fontWeight: 700,
    ...commonHeadingStyles,
  },
  h6: {
    fontSize: "1.25rem",
    fontWeight: 700,
    ...commonHeadingStyles,
  },
  caption: {
    fontSize: "0.75rem",
    fontWeight: 400,
    lineHeight: "166%",
    letterSpacing: "0.4px",
  },
  subtitle1: {
    fontSize: "1rem",
    fontWeight: 700,
    lineHeight: "175%",
    letterSpacing: "0.15px",
  },
  subtitle2: {
    fontSize: "0.875rem",
    fontWeight: 700,
    lineHeight: "157%",
  },
  body2: {
    fontSize: "0.875rem",
    fontWeight: 400,
    lineHeight: "150%",
  },
  body11: {
    fontSize: "0.625rem",
    lineHeight: "16.5px",
  },
  body13: {
    fontSize: "0.625rem",
    lineHeight: "19.5px",
  },
  body16: {
    fontSize: "1rem",
    lineHeight: "1.5rem",
    fontWeight: 400,
  },
};
